import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/programming-framework-angular.svg?component
var programming_framework_angular_exports = /* @__PURE__ */ __exportAll({
	default: () => programming_framework_angular_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M9.931 12.645h4.138l-2.07-4.908m0-7.737L.68 3.982l1.726 14.771L12 24l9.596-5.242L23.32 3.984zm7.064 18.31h-2.638l-1.422-3.503H8.996l-1.422 3.504h-2.64L12 2.65z" }, null, -1)])]);
}
var programming_framework_angular_default = { render: render$1 };
//#endregion
export { programming_framework_angular_default as default, programming_framework_angular_exports, render$1 as render };

//# sourceMappingURL=programming-framework-angular.svg.virtual.js.map